/**
 * TanStack Query hooks for `multiple-landing-pages-per-offer`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	multipleLandingPagesPerOfferQueryKeys,
	type CreateMultipleLandingPagesPerOfferBody,
	type ListMultipleLandingPagesPerOfferResponse,
	type MultipleLandingPagesPerOfferRow,
} from "./api";

export function useMultipleLandingPagesPerOfferList(): UseQueryResult<ListMultipleLandingPagesPerOfferResponse, Error> {
	return useQuery({
		queryKey: multipleLandingPagesPerOfferQueryKeys.list(),
		queryFn: list,
	});
}

export function useMultipleLandingPagesPerOfferCreate(): UseMutationResult<MultipleLandingPagesPerOfferRow, Error, CreateMultipleLandingPagesPerOfferBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: multipleLandingPagesPerOfferQueryKeys.all });
		},
	});
}

export function useMultipleLandingPagesPerOfferDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: multipleLandingPagesPerOfferQueryKeys.all });
		},
	});
}
